module.exports = __webpack_public_path__ + "static/media/F2203828-45E9-4465-B0AD-FC7EF15895B2.f59fe0be.jpeg";